// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/forms/Blocks/Events.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/forms/Blocks/Events.tsx");
  import.meta.hot.lastModified = "1740183864613.6143";
}
// REMIX HMR END

import { Fragment } from "react";
import Form from "../Form";
import { schema } from "~/routes/events.request";
import { HoneypotInputs } from "remix-utils/honeypot/react";
const Errors = {
  UNEXPECTED_ERROR: <Fragment>
      <p className="font-bold">Sorry, we couldn't send your request.</p>
      <p>Please try again or contact hq@octahedroid.com</p>
    </Fragment>
};
export default function Events({
  fetcher
}) {
  return <Form id="eventsForm" action="/events/request" buttonLabel="Submit" fetcher={fetcher} mode="onBlur" className="space-y-4 w-full flex flex-col items-center children:w-full" schema={schema} options={{
    role: [{
      name: "Select an option",
      value: "Select an option"
    }, {
      name: "C-Level",
      value: "C-Level"
    }, {
      name: "Director / Lead",
      value: "Director / Lead"
    }, {
      name: "Developer",
      value: "Developer"
    }, {
      name: "Marketing",
      value: "Marketing"
    }, {
      name: "Other",
      value: "Other"
    }],
    hearAbout: [{
      name: "Select an option",
      value: "Select an option"
    }, {
      name: "At an event",
      value: "At an event"
    }, {
      name: "By email",
      value: "By email"
    }, {
      name: "In a blog post",
      value: "In a blog post"
    }, {
      name: "On social media",
      value: "On social media"
    }, {
      name: "Someone mentioned it to me",
      value: "Someone mentioned it to me"
    }, {
      name: "Other",
      value: "Other"
    }]
  }}>
      {({
      Field,
      Button
    }) => <Fragment>
          <HoneypotInputs label="Please leave this field blank" />
          <Field name="name" label="Name" />
          <Field name="email" label="Email" />
          <Field name="company" label="Company" />
          <Field name="role" label="What is your role?" />
          <Field name="hearAbout" label="Where did you hear about us?" />
          {fetcher.data?.errors?._global && <div className="mt-4 text-center bg-error-600 p-4 text-white">
              {Errors[fetcher.data?.errors?._global]}
            </div>}
          <Button className="!w-fit justify-self-end ml-auto">Submit</Button>
        </Fragment>}
    </Form>;
}
_c = Events;
var _c;
$RefreshReg$(_c, "Events");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;